(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-hb-help]').forEach(function (root) {
      if (root === except) return;
      var panel = root.querySelector('.hb-help__panel');
      var btn = root.querySelector('.hb-help__toggle');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function initHelp(root) {
    var btn = root.querySelector('.hb-help__toggle');
    var panel = root.querySelector('.hb-help__panel');
    if (!btn || !panel || root.dataset.hbReady) return;
    root.dataset.hbReady = '1';

    function open() {
      closeAll(root);
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.hidden ? open() : close();
    });

    if (window.matchMedia('(hover: hover)').matches) {
      var timer;
      root.addEventListener('mouseenter', function () { clearTimeout(timer); open(); });
      root.addEventListener('mouseleave', function () { timer = setTimeout(close, 180); });
    }
  }

  function initMobileBurger() {
    document.querySelectorAll('[data-hb-mobile-burger]').forEach(function (btn) {
      if (btn.dataset.hbReady) return;
      btn.dataset.hbReady = '1';
      btn.addEventListener('click', function () {
        var drawer = document.querySelector('[data-drawer]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', { bubbles: false, detail: { button: btn } }));
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-hb-help]').forEach(initHelp);
    initMobileBurger();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-hb-help]')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* galerie plein écran (ordinateur) : la croix est posée dans le coin de la photo */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 750px)');
  var raf = null;

  function setImp(el, prop, val) { if (el) el.style.setProperty(prop, val, 'important'); }

  function place() {
    var p = document.querySelector('.pswp.pswp--open');
    if (!p) return false;
    var C = p.querySelector('.pswp__button--close');
    if (!C) return true;
    if (!mq.matches) {
      ['position', 'left', 'right', 'top', 'opacity'].forEach(function (k) { C.style.removeProperty(k); });
      return true;
    }
    var cx = window.innerWidth / 2, best = null, bd = 1e9;
    [].slice.call(p.querySelectorAll('.pswp__zoom-wrap img')).forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.width < 80 || r.height < 80) return;
      var dd = Math.abs((r.left + r.right) / 2 - cx);
      if (dd < bd) { bd = dd; best = r; }
    });
    if (!best || bd > 3) return true;
    var key = Math.round(best.left) + ',' + Math.round(best.top) + ',' + Math.round(best.width) + ',' + Math.round(best.height);
    if (p.__hbDone === key) return true;
    if (p.__hbCand !== key) { p.__hbCand = key; p.__hbCount = 0; return true; }
    p.__hbCount = (p.__hbCount || 0) + 1;
    if (p.__hbCount < 12) return true;
    setImp(C, 'position', 'fixed'); setImp(C, 'right', 'auto');
    var cl = parseFloat(C.style.getPropertyValue('left')) || 0;
    var ct = parseFloat(C.style.getPropertyValue('top')) || 0;
    setImp(C, 'left', Math.round(cl) + 'px'); setImp(C, 'top', Math.round(ct) + 'px');
    var r0 = C.getBoundingClientRect();
    setImp(C, 'left', Math.round(cl + (best.right - 24 - 34 - r0.left)) + 'px');
    setImp(C, 'top', Math.round(ct + (best.top + 24 - r0.top)) + 'px');
    p.__hbDone = key;
    return true;
  }

  function loop() {
    var go = false;
    try { go = place(); } catch (e) { go = false; }
    raf = go ? requestAnimationFrame(loop) : null;
  }

  new MutationObserver(function () {
    if (!raf && document.querySelector('.pswp.pswp--open')) loop();
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'], childList: true });
})();

/* ===== Montage : bouton « Ajouter le montage » dans le panier ===== */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ma-upsell]'); if(!b||b.disabled) return;
    e.preventDefault(); b.disabled=true; b.textContent='Ajout…';
    var key=b.getAttribute('data-key'), qty=parseInt(b.getAttribute('data-qty')||'1',10), vid=parseInt(b.getAttribute('data-variant'),10);
    var post=function(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){if(!r.ok) throw new Error(r.status); return r.json();});};
    post('/cart/add.js',{items:[{id:vid,quantity:qty}]})
      .then(function(){return post('/cart/change.js',{id:key,quantity:0});})
      .then(function(){window.location.reload();})
      .catch(function(){b.disabled=false;b.textContent='Ajouter le montage';});
  });
})();

/* ===== Table basse offerte : rappel visible + confirmation du choix ===== */
(function(){
  function tick(){
    var p=document.querySelector('.otb-picker'); if(!p) return;
    var act=p.querySelector('.otb-picker__opt.is-active');
    var st=p.querySelector('.otb-picker__status');
    if(!st){ st=document.createElement('p'); st.className='otb-picker__status'; var anchor=p.querySelector('.otb-picker__dims')||p.querySelector('.otb-picker__options'); anchor.parentNode.insertBefore(st,anchor.nextSibling); }
    var nm=act?(act.querySelector('.otb-picker__name b')||{}).textContent:'';
    var html=nm?('✓ Table basse sélectionnée : <b>'+nm+'</b>. Elle est ajoutée <b>gratuitement</b> avec votre canapé.'):'Choisissez votre table basse offerte ci-dessus.';
    if(st.__h!==html){ st.innerHTML=html; st.__h=html; }
    if(!document.querySelector('.otb-hint')){
      var pr=document.querySelector('.product__price, .price, [class*=product__price]'); var host=document.querySelector('.product__selectors'); 
      var a=document.createElement('a'); a.className='otb-hint'; a.href='#'; a.innerHTML='🎁 Une table basse est offerte avec ce canapé : <u>choisissez-la plus bas</u>';
      a.addEventListener('click',function(e){ e.preventDefault(); p.scrollIntoView({behavior:'smooth',block:'center'}); });
      var ref=document.querySelector('.product__selectors'); if(ref&&ref.parentNode) ref.parentNode.insertBefore(a,ref);
    }
  }
  setInterval(tick,600);
})();

/* Galerie par taille : les images dont l'alt contient "90x190" ne sont affichees que pour la taille 90x190 (les autres sont retirees du DOM pour que l'image principale et le zoom ne montrent que le bon jeu) */
(function(){
  var orig=null, last=null;
  function size(){ var r=document.querySelector('input[type=radio]:checked[value$="x190"], input[type=radio]:checked[value$="x200"]'); return r?String(r.value).trim():''; }
  function is90(n){ var i=n.querySelector('img'); return !!(i&&/90x190/.test(i.alt||'')); }
  function apply(){
    var sp=document.querySelector('.product__slides'); var tp=document.querySelector('.product__thumbs__holder');
    if(!sp) return;
    if(!orig){
      var s=[].slice.call(sp.querySelectorAll(':scope > .product__slide'));
      if(!s.some(is90)) return;
      orig={s:s,t:tp?[].slice.call(tp.querySelectorAll(':scope > .product__thumb')):[]};
      var z=document.querySelector('zoom-images');
      if(z&&z.createZoom&&!z.__g90){
        z.__g90=true; var all=[].slice.call(z.querySelectorAll('[data-zoom-image]')); var proto=z.createZoom;
        z.createZoom=function(t){ var node=all[t]; var cur=[].slice.call(z.querySelectorAll('[data-zoom-image]')); z.images=cur; var k=cur.indexOf(node); proto.call(z,k<0?0:k); };
      }
    }
    var want=size()==='90x190';
    if(last===want) return; last=want;
    function set(parent,arr){ if(!parent) return; arr.forEach(function(n){ if(n.parentNode===parent) parent.removeChild(n); }); arr.filter(function(n){return is90(n)===want;}).forEach(function(n){ parent.appendChild(n); }); }
    set(sp,orig.s); set(tp,orig.t);
    var tpl=document.querySelector('[data-pswp-thumbs-template]');
    if(tpl){ if(!orig.f){ var tmp=document.createElement('div'); tmp.innerHTML=tpl.innerHTML; orig.f=[].slice.call(tmp.children); }
      tpl.innerHTML=orig.f.filter(function(f,i){ return orig.s[i]&&is90(orig.s[i])===want; }).map(function(f){return f.outerHTML;}).join('\n'); }
    var first=sp.querySelector('.product__slide'); sp.querySelectorAll('.product__slide').forEach(function(n){ n.classList.remove('media--active'); n.classList.add('media--hidden'); n.style.display=''; });
    if(first){ first.classList.add('media--active'); first.classList.remove('media--hidden'); }
    if(tp){ tp.querySelectorAll('.product__thumb').forEach(function(n,k){ n.classList.toggle('is-active',k===0); n.style.display=''; }); }
    window.dispatchEvent(new Event('resize'));
  }
  setInterval(apply,500);
})();

/* Textes par taille : 90x190 = 1 oreiller offert (sous-titre et description) */
(function(){
  var store=new WeakMap(), last=null;
  function size(){ var r=document.querySelector('input[type=radio]:checked[value$="x190"], input[type=radio]:checked[value$="x200"]'); return r?String(r.value).trim():''; }
  function conv(t){ return t.replace(/2 (O|o)reillers (O|o)fferts/g,function(m,a,b){ return '1 '+a+'reiller '+b+'ffert'; }); }
  function apply(){
    if(!document.querySelector('input[type=radio][value="90x190"]')) return;
    var is90=size()==='90x190'; if(last===is90) return; last=is90;
    var root=document.querySelector('product-info')||document.body;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);
    var n,list=[]; while((n=w.nextNode())) list.push(n);
    list.forEach(function(t){
      var p=t.parentElement; if(!p||/^(STYLE|SCRIPT|TITLE|TEMPLATE)$/.test(p.tagName)||p.closest('.product-item,.cart-bar')) return;
      if(is90){ if(/2 (O|o)reillers (O|o)fferts/.test(t.nodeValue)){ if(!store.has(t)) store.set(t,t.nodeValue); t.nodeValue=conv(t.nodeValue); } }
      else if(store.has(t)){ t.nodeValue=store.get(t); store.delete(t); }
    });
  }
  setInterval(apply,500);
})();
